/**
 * Available icons
 * @enum {string}
 */
export enum Icon {
  ArrowDown = 'arrow-down',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowLink = 'arrow-link',
  ArrowUp = 'arrow-up',
  Bars = 'bars',
  Check = 'social-check',
  Copy = 'social-link',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  CircleArrowRight = 'circle-arrow-right',
  Close = 'cross',
  Cross = 'cross',
  Email = 'social-email',
  Facebook = 'social-facebook',
  Instagram = 'instagram',
  LinkedIn = 'social-linkedin',
  Menu = 'bars',
  Share = 'share',
  Tick = 'check',
  TpxArrow = 'tpx-arrow',
  TpxArrowWithLoop = 'tpx-arrow--with-loop',
  TikTok = 'social-tiktok',
  Twitter = 'social-twitter',
  YouTube = 'social-youtube',
}